import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models (FL140 + FL040Info)
// ============================================================

export interface FL040Info {
  fl040_01: string;          // 文件編號
  fl040_11: string;          // 文件名稱
  fl040_12: string | null;   // 製訂日期
  fl040_13: string | null;   // 修改日期
  fl040_14: string;          // 版次
  fl040_15: number;          // 總頁數
  fl040_80: string;          // 核准狀態
}

export interface FL140 {
  fl140_01: string;          // 文件編號 PK part1
  fl140_02: number;          // 頁次 PK part2 (float: 1, 1.5, 2, ...)
  fl140_11: string;          // 章節代號
  fl140_12: string;          // 章節名稱
  fl140_13: string;          // 備用
  fl140_21: string;          // 頁面內容 (Memo)
  fl140_79: boolean;         // 稽核旗標
  fl140_80: string;          // 核准狀態
  fl140_81: string;          // 異動人員代號
  fl140_82: string | null;   // 異動日期
  fl140_83: string;          // 稽核欄位
  fl140_84: string;          // 異動人員代號2
  fl140_85: string | null;   // 異動日期2
  fl140_91: string;          // 建立人員
  fl140_92: string | null;   // 建立日期
  fl140_93: string;          // 備用

  // Read-only parent info (populated by service)
  parent_doc?: FL040Info;
}

// ============================================================
// Request / Response types
// ============================================================

export interface L204ListResponse {
  data: FL140[];
  total: number;
  page: number;
  size: number;
}

export interface L204CreateRequest {
  fl140_01: string;   // 文件編號
  fl140_02: number;   // 頁次
  fl140_11: string;   // 章節代號
  fl140_12: string;   // 章節名稱
  fl140_13: string;   // 備用
  fl140_21: string;   // 頁面內容
}

export interface L204UpdateRequest {
  fl140_11: string;   // 章節代號
  fl140_12: string;   // 章節名稱
  fl140_13: string;   // 備用
  fl140_21: string;   // 頁面內容
}

export interface ValidationError {
  field: string;
  rule: string;
  message: string;
}

// ============================================================
// API methods
// ============================================================

export const l204Api = {
  async list(page = 1, size = 20, docNo?: string, keyword?: string): Promise<L204ListResponse> {
    const params: Record<string, string | number> = { page, size };
    if (docNo) params.docNo = docNo;
    if (keyword) params.keyword = keyword;
    const res = await apiClient.get('/api/l204', { params });
    return res.data;
  },

  async get(docNo: string, pageNo: number): Promise<FL140> {
    const res = await apiClient.get(
      `/api/l204/${encodeURIComponent(docNo)}/${encodeURIComponent(String(pageNo))}`
    );
    return res.data;
  },

  async create(data: L204CreateRequest): Promise<FL140> {
    const res = await apiClient.post('/api/l204', data);
    return res.data;
  },

  async update(docNo: string, pageNo: number, data: L204UpdateRequest): Promise<FL140> {
    const res = await apiClient.put(
      `/api/l204/${encodeURIComponent(docNo)}/${encodeURIComponent(String(pageNo))}`,
      data
    );
    return res.data;
  },

  async delete(docNo: string, pageNo: number): Promise<void> {
    await apiClient.delete(
      `/api/l204/${encodeURIComponent(docNo)}/${encodeURIComponent(String(pageNo))}`
    );
  },
};
